module.exports = __webpack_public_path__ + "img/Monochrome_Logo_Horizontal.35d4d52f.svg";